<template>
	<div class="mima" v-if="">
		<div class="con">
			<p class="con_tit"><span></span><strong>修改密码</strong></p>
			<div class="con_con">
				<p>请输入旧密码</p>
				<input type="text" v-model="old1" />
				<p>输入新密码</p>
				<input type="text" v-model="new1" placeholder="最少6位数字+字母密码" />
				<p>重复新密码</p>
				<input type="text" v-model="news" />
				<button class="btn" @click="summit">提交</button>
			</div>
		</div>
	</div>
</template>

<script>
	import { Message } from 'element-ui'
	import Qs from 'qs'
	export default {
		data() {
			return {
				old1: '',
				new1: '',
				news: '',
			};
		},
		props: {
			showMima: {
				type: Boolean
			}
		},
		created() {},
		mounted() {

		},
		methods: {
			summit() {
				var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
				if(!this.old1) {
					this.$toast("请输入旧密码");
					return false;
				};
				if(!this.new1) {
					this.$toast("请输入新密码");
					return false;
				}
				if(!reg.test(this.new1)) {
					this.$toast("最少6位数字+字母密码");
					return false;
				}
				if(this.new1 != this.news) {
					this.$toast("新密码两次输入不一致");
					return false;
				}
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				};
				var data = {
					'access-token':token,
					'old_code': this.old1,
					'code': this.new1,
					'recode': this.news,
				};				
				this.$axios({
					method: 'post',
					url: 'home/passwd',
					data: Qs.stringify(data)
				}).then(response => {
					console.log(response.data)
					switch(Number(response.data.state)) {
						case 2:
							this.$message({
					          	showClose: true,
					          	message:'原密码错误，请确认',
					          	type: 'error'
					       });
							break;
						case 4:
							this.$message({
					          	showClose: true,
					          	message: '密码修改成功',
					          	type: 'success'
					       });
							break;
						default:
							this.$message({
					          	showClose: true,
					          	message:response.data.msg,
					          	type: 'error'
					       });
					}
				});
			},
			close() {
				this.suc = false;
			},
			close1() {
				this.failed = false;
			}
		}
	}
</script>
<style scoped>
	.mima {
		padding: 0 18px 18px;
		box-sizing: border-box;
		width: 100%;
		height: auto;
		background: #fff;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #404040;
		text-align: left;
	}
	
	.con {
		width: 100%;
		height: auto;
		position: relative;
		overflow: hidden;
	}
	
	.con_tit {
		color: #005EB3;
		font-size: 18px;
		line-height: 45px;
		font-weight: bold;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.con_tit span{
		width:4px;
		height:16px;
		background:#4799E4;
		margin-right: 7px;
	}
	.con_con {
		width: 100%;
		height: 580px;
	}
	
	.con_con p {
		margin-bottom: 11px;
	}
	
	.con_con input {
		margin-bottom: 23px;
		width: 453px;
		height: 42px;
		background: rgba(255, 255, 255, 1);
		border: 1px solid rgba(206, 206, 206, 1);
		text-indent: 25px;
	}
	
	.con_con .btn {
		display: block;
		width: 160px;
		height: 48px;
		background: rgba(0, 118, 255, 1);
		border-radius: 4px;
		border: none;
		color: #fff;
		margin-bottom: 27px;
	}
	
</style>


// WEBPACK FOOTER //
// src/components/Mima.vue